import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserDetailComponent } from '../dashboard/user-detail/user-detail.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DashService } from '../dashboard/dash.service';
import { EnvService } from '../env.service';
import * as moment from 'moment';

@Component({
  selector: 'app-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ActivitylogComponent implements OnInit {

  isLoadingLogs = false;
  logs:[]

  constructor(public userDetails: UserDetailComponent, private route: ActivatedRoute, private http: HttpClient, private router: Router, public dashService: DashService, private env: EnvService) { }

  ngOnInit(): void {
    this.getLogs();
  }

  getLogs(){
    this.isLoadingLogs = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/activitylogs")
              .subscribe(response => {
                this.isLoadingLogs = false;
                console.log(response);
                let logsTemp = response["logs"];
                logsTemp.forEach(log=>{
                  log.date = moment(log.date).format("lll");
                })
                this.logs = logsTemp;
              }, err => {
                console.log(err);
                this.isLoadingLogs = false;
              })
  }

}
